import $ from 'jquery';

$( document ).on( 'click', '.js-accordion-toggle', function( event ) {
	const $this = $( this );

	if ( $this.parent().hasClass( 'is-expanded' ) ) {
		$this.parent().removeClass( 'is-expanded' );
		$this.next().slideUp( 300 );
	} else {
		$this.parents( '.js-accordion' ).find( '.js-accordion-toggle' ).parent().removeClass( 'is-expanded' );
		$this.parents( '.js-accordion' ).find( '.js-accordion-panel' ).slideUp( 350 );
		$this.parent().toggleClass( 'is-expanded' );
		$this.next().slideToggle( 300 );
	}
} );

$( document ).on( 'click', '.js-accordion-toggle a', function( event ) {
	event.stopPropagation();
} );